export default __webpack_public_path__ + "media/success-green-check-circle-o.1af6e695.svg";